import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { ManageOrganizations } from '#screens/Settings';

export const SettingsNavigator = () => (
  <Routes>
    <Route path="organizations" element={<ManageOrganizations />} />
    <Route path="*" element={<Navigate to="organizations" />} />
  </Routes>
);
